import { createStackNavigator } from "@react-navigation/stack";
import ImageGalleryScreen from "../components/products/imageGallery/imageGalleryScreen";


const ImageGalleryStack = () => {
   const MailLogs = createStackNavigator()
   return (
      <MailLogs.Navigator initialRouteName="ImageGalleryScreen" screenOptions={{
         headerShown: false,
      }}>
          <MailLogs.Screen name="ImageGalleryScreen" component={ImageGalleryScreen} />
      </MailLogs.Navigator>
   )
}

export default ImageGalleryStack